<head>
<link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons'>
<link rel='stylesheet' href='https://cdn.jsdelivr.net/npm/vuetify@1.5.6/dist/vuetify.min.css'>

</head>
<template>
  <div id="app">
    <!-- <div class="container-fluid" > -->
    <nav class="navbar fixed-top navbar-expand-lg navbar-light">
      <a href="index" class="logo-background">
        <div style="padding: 5px; margin: 0px">
          <img
            class="navbar-brand logo"
            src="./assets/logo/NatourMontenegroLG.png"
          />
        </div>
        <!-- <div style="padding:0px;margin-top:-10px;"><img class="navbar-brand logo-tekst" src="./assets/nmLogoTekst2.png"></div> -->
      </a>

      <!-- Toggler/collapsibe Button -->
      <button
        class="navbar-toggler navbar-dark"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavbar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <!-- Links -->
        <ul class="navbar-nav w-100 nav-justified">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href=""
              id="navbardrop1"
              data-toggle="dropdown"
            >
              Natour
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" href="daytours"> Day trips </a>
                <!-- <ul class="submenu dropdown-menu">
                <li><a class="dropdown-item" href="daytours"> Among the peaks, katuns, shepherds…</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
              </ul> -->
              </li>
              <li>
                <a class="dropdown-item" href="multidaytours">
                  Multi-day tours</a
                >
                <!-- <ul class="submenu dropdown-menu">
                <li><a class="dropdown-item" href=""> Among the peaks, katuns, shepherds…</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
              </ul> -->
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href=""
              id="navbardrop2"
              data-toggle="dropdown"
            >
              Cultour
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" href="cultour"> Day trips </a>
                <!-- <ul class="submenu dropdown-menu">
                <li><a class="dropdown-item" href="daytours"> Among the peaks, katuns, shepherds…</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
              </ul> -->
              </li>
              <li>
                <a class="dropdown-item" href="cultour_multiday">
                  Multi-day tours</a
                >
                <!-- <ul class="submenu dropdown-menu">
                <li><a class="dropdown-item" href=""> Among the peaks, katuns, shepherds…</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
                <li><a class="dropdown-item" href=""> Among the birds and liliies</a></li>
              </ul> -->
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="rural">Rural Montenegro</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="familybuilding">Family building</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="tailormade">Tailor made tours</a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link" href="#">Activities</a>
          </li> -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbardrop"
              data-toggle="dropdown"
              >Places to go</a
            >
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" href="placestogo1"> Skadar Lake </a>
              </li>
              <li>
                <a class="dropdown-item" href="placestogo2">
                  Old Montenegro Region</a
                >
              </li>
              <li>
                <a class="dropdown-item" href="placestogo3">
                  Podgorica and its surroundings
                </a>
              </li>
              <li>
                <a class="dropdown-item" href="placestogo4">
                  Old towns of the South</a
                >
              </li>
              <li>
                <a class="dropdown-item" href="placestogo5">
                  North of Montenegro</a
                >
              </li>
              <li>
                <a class="dropdown-item" href="placestogo6"> UNESCO sites</a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbardrop"
              data-toggle="dropdown"
              >Useful</a
            >
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" href="about">About us</a>
              </li>
              <li>
                <a class="dropdown-item" href="blog">
                  Blog</a>
              </li>
              <!-- <li>
                <a class="sublist dropdown-item" href="#">
                  Places to go
                </a>
                <ul class="submenu dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="placestogo1"> Skadar Lake </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="placestogo2">
                      Old Montenegro Region</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="placestogo3">
                      Podgorica and its surroundings
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="placestogo4">
                      Old towns of the South</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="placestogo5">
                      North of Montenegro</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" href="placestogo6"> UNESCO sites</a>
                  </li>
                </ul>
              </li> -->
              <li>
                <a class="dropdown-item" href="terms">
                  Terms And Conditions</a>
              </li>
              <li>
                <a class="dropdown-item" href="policy">
                  Responsible Travel Policy</a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="contact">Contact us</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-social-links"
              target="_blank"
              href="https://www.instagram.com/natourmontenegro/"
              ><i class="fab fa-instagram"></i>
            </a>
            <a
              class="nav-social-links"
              target="_blank"
              href="https://www.facebook.com/Natour-Montenegro-Tours-Experiences-101466425389212"
              ><i class="fab fa-facebook"></i>
            </a>
            <a
              class="nav-social-links"
              target="_blank"
              href="https://en.tripadvisor.com.hk/Attraction_Review-g304088-d23329111-Reviews-Natour_Montenegro_travel_agency-Podgorica_Podgorica_Municipality.html"
              ><i class="fab fa-tripadvisor"></i>
            </a>
            <!-- <a class="nav-social-links" target="_blank" href="https://www.facebook.com/pages/Crna%20Gora/109828182370402/"><i class="fab fa-linkedin"></i> </a>
          <a class="nav-social-links" target="_blank" href="https://www.facebook.com/pages/Crna%20Gora/109828182370402/"><i class="fab fa-twitter"></i></a> -->
          </li>
        </ul>
      </div>
    </nav>
    <!-- <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-4 offset-md-4 mt-5">
                        <div class="card p-2">
                            <form @submit.prevent="registerUser">
                                <div class="form-group">
                                    <label for="name">Name</label>
                                    <input v-model="user.name" type="text" class="form-control" id="name">
                                </div>
                                <div class="form-group">
                                    <label for="email">Email address</label>
                                    <input v-model="user.email" type="email" class="form-control" id="email">
                                </div>
                                <div class="form-group">
                                    <label for="phone">Phone</label>
                                    <input v-model="user.phone" type="text" class="form-control" id="phone">
                                </div>
                                <button class="btn btn-primary" type="submit">
                                     <span v-if="loader" class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
                                    Submit
                                </button>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    <!-- </div>  -->
    <router-view />

    <!-- <div >
    <Slider/>
  </div> -->

    <Footer />

    <!-- <img src="./assets/logo.png"> -->
  </div>
</template>

<script src="main.js"></script>

<script>
import Footer from "./components/Footer";
// import Slider from "./components/ImageSlider";
// import VueLitebox from 'vue-litebox';
// import Gallery from "./components/IndexGallery";

export default {
  name: "App",
  components: {
    Footer,
  },
  mounted() {
      let bokunScript = document.createElement('script')
      bokunScript.setAttribute('src', 'https://widgets.bokun.io/assets/javascripts/apps/build/BokunWidgetsLoader.js?bookingChannelUUID=c915da34-3197-43bd-a069-eb7acecf8f66')
      bokunScript.setAttribute('async','')
      document.head.appendChild(bokunScript)
    }
};
</script>

<style>
html,
body {
  overflow-x: hidden;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #626364;
  /* margin-top: 5px; */
  /* background-image: url("assets/nature2.png"); */
  background-image: url("assets/background03@5x.png");
  /* background-image: url("assets/back03.png"); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  margin-right: 0px;
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue